"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDefaultHealth = void 0;
const ScrapeInfo_1 = require("./ScrapeInfo");
const getDefaultHealth = () => ({
    isDataFake: true,
    scrapeInfo: ScrapeInfo_1.getDefaultScrapeInfo(),
    buildInfo: null,
});
exports.getDefaultHealth = getDefaultHealth;
//# sourceMappingURL=Health.js.map